export default __webpack_public_path__ + "static/media/52t.c309861a.jpg";